
import barba from '@barba/core';

export default class{

	constructor(){
        barba.hooks.beforeOnce((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {
            this.init()
        });
    }
    init (){
        const iframes = document.querySelectorAll('.blog-body iframe:not(.wp-embedded-content)')
        if(iframes.length > 0){
            iframes.forEach(i => {
                i.outerHTML = '<div class="yt-wrapper">' + i.outerHTML + '</div>';
            })
        }
    }
}